import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=8d5cd008&"
import script from "./header.component.vue?vue&type=script&lang=js&"
export * from "./header.component.vue?vue&type=script&lang=js&"
import style0 from "./header.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports